import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface SponsorshipTier {
  id: string;
  name: string;
  level: number;
  benefits: string[];
  currency: string;
  price_min: number | null;
  price_max: number | null;
  is_active: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
}

export const useSponsorshipTiers = () => {
  const [tiers, setTiers] = useState<SponsorshipTier[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTiers = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from("sponsorship_tiers")
        .select("*")
        .eq("is_active", true)
        .order("display_order", { ascending: true });

      if (error) throw error;
      
      // Transform the data to ensure benefits is properly typed
      const transformedData = (data || []).map(tier => ({
        ...tier,
        benefits: Array.isArray(tier.benefits) 
          ? (tier.benefits as string[])
          : typeof tier.benefits === 'string' 
            ? [tier.benefits] 
            : []
      })) as SponsorshipTier[];
      
      setTiers(transformedData);
      setError(null);
    } catch (error: any) {
      console.error('Error fetching sponsorship tiers:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTiers();
  }, []);

  return {
    tiers,
    loading,
    error,
    refetch: fetchTiers
  };
};